import React, { useState, useContext, useEffect, useRef} from 'react';
import { AppBar, Toolbar, Typography, IconButton, MenuList, Drawer, Link, List, ListItem, ListItemText, Box, Avatar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { ArrowBack, Menu, LightMode, DarkMode, SupportAgent } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import Profile from './../pages/Profile';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import config from '../config';
import { apiAppFetch } from '../utils/apiFetch';
import './../Profile.css';
import './../index.css';
import { getToken, storeToken, removeToken } from '../utils/auth';

function TitleBar() {
  const { userDetails, isRefreshing, trades, netPositions, refreshTradesAndPortfolio } = useContext(WebSocketContext);
  const { isDarkMode, toggleTheme } = useTheme(); // Used useTheme hook
  const location = useLocation();
  const navigate = useNavigate();
  const userId = Number(localStorage.getItem('userId'));
  const user_id = Number(localStorage.getItem('userId'));
  const parent_id = Number(localStorage.getItem('parentId'));
  const user_type = "brokerMLM";
  const clientName = userDetails.clientName;
  const isMLMClient = userDetails?.isMLMClient === "1";
  const intervalRef = useRef(null);

  const whatsappNumber = userDetails.supportContact;
  const whatsappMessage = 'Hello, I need support';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const referralLink = `https://app.papertrade.co.in/register?ud=${userId}`;
  const message = encodeURIComponent(
    `Hi! Join using my referral link: ${referralLink}`
  );

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const [marqueeText, setMarqueeText] = useState(null);

  const getTodayScrollText = async () => {
      try 
      {  
        const response = await apiAppFetch('getDefaultScrollText', {
          method: 'POST',
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setMarqueeText(data.text); 

      } catch (error) {
        // fetch failed silently
      }
  };

  useEffect(() => {
    getTodayScrollText();
    }, []);

  useEffect(() => {
    const ua = window.navigator.userAgent || '';
    const isIPhone = /iPhone/i.test(ua);
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setShowAddToHomeScreen(isIPhone && !isStandalone);
  }, []);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [showAddToHomeScreen, setShowAddToHomeScreen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Auto-refresh trades every 10 seconds if there are pending orders
  useEffect(() => {
    // Check if there are any pending orders
    const hasPendingOrders = trades.some(trade => trade.orderStatus == "1");

    if (hasPendingOrders) {
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      
      // Set up new interval for 10 seconds
      intervalRef.current = setInterval(() => {
        console.log('Auto-refreshing trades due to pending orders...');
        refreshTradesAndPortfolio("both");
      }, 10000); // 10 seconds
      
      console.log('Auto-refresh started for pending orders');
    } else {
      // Clear interval if no pending orders
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        console.log('Auto-refresh stopped - no pending orders');
      }
    }

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [trades]);

  const handleNavigation = (path) => () => {
      setIsMLMMenu(false);
      
      if (path.startsWith('http')) {
        window.open(path, '_blank');
      } else {
        navigate(path);
        location.pathname = path;
      }
      setDrawerOpen(false);
  };

  const doLogin = async (opts = {}) => {
    const { disableAccount = false } = opts;
    if (disableAccount) {
      try {
        const uid = Number(localStorage.getItem('userId'));
        if (uid) {
          await apiAppFetch('enableDisableUser', {
            method: 'POST',
            body: JSON.stringify({ status: 0 }),
          });
        }
      } catch (e) {
        // continue logout even if disable fails
      }
    }
    localStorage.removeItem('authToken');
    removeToken();
    setDrawerOpen(false);
    setSupportDialogOpen(false);
    navigate('/login');
  };

  const handleSupportMenuClick = () => {
    setSupportDialogOpen(true);
  };

  const handleSupportConfirmYes = () => {
    doLogin({ disableAccount: true });
  };

  const handleSupportConfirmNo = () => {
    // window.open(whatsappLink, '_blank');
    setSupportDialogOpen(false);
    setDrawerOpen(false);
  };

  const handleAddToHomeScreen = () => {
    alert('To add this app to your Home Screen:\n1) Tap the Share icon in Safari\n2) Select "Add to Home Screen"\n3) Tap "Add"');
  };

  const showBackButton = location.pathname === '/profile' || location.pathname === '/addScript';

  const [isMLMMenuOpen, setIsMLMMenu] = useState(false);

  const toggleMLMMenu = () => {
    setIsMLMMenu(!isMLMMenuOpen);
  };

  return (
    <>
      <AppBar 
        position="fixed" 
        color="primary"
        className="app-title-bar"
        style={{ 
          backgroundColor: isDarkMode ? 'var(--bg-primary)' : '#FFFFFF', // Theme-aware background
          boxShadow: isDarkMode ? '0px 2px 5px -2px rgba(255,255,255,0.1)' : 'none', // Theme-aware shadow
          color: isDarkMode ? 'var(--text-primary)' : 'black', // Theme-aware text color
          borderBottom: isDarkMode ? '0px solid var(--border-color)' : 'none' // Theme-aware border
        }}
      >
        <Toolbar style={{ minHeight:'45px' }}>
          {showBackButton && (
            <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
              <ArrowBack />
            </IconButton>
          )}
          {true && showBackButton==false && (
            <IconButton edge="start" color="inherit" onClick={toggleDrawer(true)}>
              <Menu />
            </IconButton>
          )}
          <Typography variant="h6" style={{fontSize:'18px', fontFamily:'Lato', fontWeight:600}}>
            {location.pathname === '/' && 'Quotes'} {/* Changed to Quotes */}
            {location.pathname === '/trades' && 'Trades'}
            {location.pathname === '/portfolio' && 'Portfolio'}
            {location.pathname === '/positions' && 'Positions'}
            {location.pathname === '/profile' && 'Profile'}
            {location.pathname === '/performance' && 'Performance'}
            {location.pathname === '/blocked-scripts' && 'Blocked Scripts'}
            {location.pathname === '/change-password' && 'Change Password'}
            {location.pathname === '/addScript' && 'Add Script'}
            {location.pathname === '/rejection-logs' && 'Rejection Logs'}
            {location.pathname === '/quantity-setting' && 'Quantity Setting'}
            {location.pathname === '/ledger' && 'Ledger'}
            {location.pathname === '/mlmdashboard' && 'MLM Trades'}
            {location.pathname === '/mlmportfolio' && 'MLM Portfolio'}
            {location.pathname === '/mlmperformance' && 'MLM Performance'}
          </Typography>
          {/* Action buttons for Quotes page */}
          {/* {location.pathname === '/' && (
            <>
              <IconButton color="inherit" onClick={() => { }}>
                <Star />
              </IconButton>
            </>
          )} */}
          <IconButton color="error" onClick={handleSupportMenuClick} style={{ marginLeft: 'auto' }} title="Support">
            <SupportAgent />
          </IconButton>
          <IconButton color="inherit" onClick={toggleTheme}>
            {isDarkMode ? <LightMode /> : <DarkMode />}
          </IconButton>
        </Toolbar>
        {/* <marquee style={{
          fontSize:'12px', 
          fontFamily: 'Lato',
          marginTop:'-5px', 
          marginBottom:'5px', 
          fontWeight:'bold',
          color: isDarkMode ? 'var(--text-primary)' : 'inherit' // Theme-aware color
        }}>
          {marqueeText}
        </marquee> */}

        {isRefreshing && <div style={{position: 'absolute', width: '100%', top: 'calc(var(--safe-area-top) + 10px)'}}>
          <div style={{
            fontSize: '11px', 
            color: isDarkMode ? 'var(--text-primary)' : '#062c2f', 
            background: isDarkMode ? 'var(--bg-secondary)' : 'white', 
            padding: '0px 7px', 
            borderRadius: '11px', 
            margin: '0px auto', 
            width: '81px',
            border: isDarkMode ? '1px solid var(--border-color)' : 'none' // Theme-aware border
          }}>
            Refreshing....
          </div>
        </div>}
      </AppBar>

      

      {/* Compact Redesigned Drawer */}
      <Drawer 
        anchor="left" 
        open={drawerOpen} 
        onClose={toggleDrawer(false)} 
        PaperProps={{
          className: 'app-side-drawer',
          sx: {
            backgroundColor: isDarkMode ? '#1a1a1a' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#000000',
            width: '280px',
            boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)',
            boxSizing: 'border-box',
            paddingBottom: 'var(--safe-area-bottom)'
          }
        }}
      >
        {/* Compact Header Section */}
        <div
          className="app-side-drawer-header"
          style={{
          padding: '16px',
          borderBottom: `1px solid ${isDarkMode ? '#333333' : '#e0e0e0'}`,
          background: isDarkMode ? '#1a1a1a' : '#f8f9fa'
        }}>
          {userDetails && (
            <div style={{
                    display: 'flex',
                    alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
                  <Avatar
                    sx={{
                  width: 40,
                  height: 40,
                  bgcolor: isDarkMode ? 'var(--accent-color)' : '#e3f2fd',
                  color: isDarkMode ? '#ffffff' : '#1976d2',
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                {userDetails.clientName && userDetails.clientName.split(" ").map((n) => n[0]).join("").toUpperCase()}
                  </Avatar>
              <div>
                <Typography variant="h6" sx={{ 
                  fontWeight: 600, 
                  color: isDarkMode ? '#ffffff' : '#000000',
                  fontSize: '16px',
                  marginBottom: '2px',
                  lineHeight: 1.2
                }}>
                    {userDetails.clientName}
                  </Typography>
                <Typography variant="body2" sx={{ 
                  color: isDarkMode ? '#aaaaaa' : '#666666',
                  fontSize: '12px'
                }}>
                    ID: {userDetails.clientId}
                  </Typography>
              </div>
            </div>
          )}

          {/* Compact Balance Cards */}
          <div style={{
            // display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '8px',
            marginBottom: '16px'
          }}>
                  <div style={{
                    background: isDarkMode ? '#2d2d2d' : '#ffffff',
                    padding: '12px',
                    borderRadius: '8px',
                    border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                    textAlign: 'center'
                  }}>
                    <Typography variant="body2" sx={{ 
                      color: isDarkMode ? '#aaaaaa' : '#666666',
                      fontSize: '10px',
                      fontWeight: 500,
                      marginBottom: '2px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      Available Margin
                    </Typography>
                    <Typography variant="h6" sx={{ 
                      color: isDarkMode ? '#ffffff' : '#000000',
                      fontSize: '14px',
                      fontWeight: 700
                    }}>
                      ₹{Number(userDetails.availableMargin).toFixed(2)}
                    </Typography>
                  </div>
                  {/* <div style={{
                    background: isDarkMode ? '#2d2d2d' : '#ffffff',
                    padding: '12px',
                    borderRadius: '8px',
                    border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                    textAlign: 'center'
                  }}>
                    <Typography variant="body2" sx={{ 
                      color: isDarkMode ? '#aaaaaa' : '#666666',
                      fontSize: '10px',
                      fontWeight: 500,
                      marginBottom: '2px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      Available Balance
                    </Typography>
                    <Typography variant="h6" sx={{ 
                      color: isDarkMode ? '#ffffff' : '#000000',
                      fontSize: '14px',
                      fontWeight: 700
                    }}>
                      ₹{Number(userDetails.mainAmount).toFixed(2)}
                    </Typography>
                  </div> */}
            </div>
            </div>

        {/* Compact Navigation Section */}
        <div style={{
          padding: '4px 0',
          flex: 1,
          overflowY: 'auto'
        }}>
          {/* Main Navigation */}
          <div style={{ padding: '4px 0' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11px',
              fontWeight: 600,
              color: isDarkMode ? '#888888' : '#666666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '4px'
            }}>
              Account
            </div>
            
            {[
              { icon: '🚫', label: 'Blocked Scripts', path: '/blocked-scripts' },
              { icon: '📋', label: 'Rejection Logs', path: '/rejection-logs' },
              { icon: '⚙️', label: 'Quantity Setting', path: '/quantity-setting' },
              { icon: '📊', label: 'Ledger', path: '/ledger' },
              { icon: '🔐', label: 'Change Password', path: '/change-password' }
            ].map((item, index) => (
              <div
                key={index}
                onClick={() => handleNavigation(item.path)()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>{item.icon}</span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          {/* Compact MLM Section */}
              {isMLMClient && (
            <div style={{ padding: '4px 0' }}>
              <div style={{
                padding: '8px 16px',
                fontSize: '11px',
                fontWeight: 600,
                color: isDarkMode ? '#888888' : '#666666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '4px'
              }}>
                MLM
              </div>
              
              <div
                onClick={toggleMLMMenu}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>
                  {isMLMMenuOpen ? '📊' : '📊'}
                </span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  MLM Dashboard
                </span>
              </div>

                      {isMLMMenuOpen && (
                <div style={{ marginLeft: '16px' }}>
                  {[
                    { icon: '📈', label: 'Trades', path: '/mlmdashboard' },
                    { icon: '💼', label: 'Portfolio', path: '/mlmportfolio' },
                    { icon: '📊', label: 'Performance', path: '/mlmperformance' },
                    { icon: '📋', label: 'MLM Ledger', path: `https://bluerock.live/broledger_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}`, external: true },
                    { icon: '📄', label: 'MLM Summary', path: `https://bluerock.live/summaryReport_mlm.php?ud=${userId}&r=${user_type}&mid=${parent_id}`, external: true }
                  ].map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleNavigation(item.path)()}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '6px 16px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        borderLeft: '2px solid transparent'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                        e.target.style.borderLeftColor = 'var(--accent-color)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.borderLeftColor = 'transparent';
                      }}
                    >
                      <span style={{ fontSize: '14px', marginRight: '12px', width: '18px' }}>{item.icon}</span>
                      <span style={{ 
                        fontSize: '12px',
                        fontWeight: 500,
                        color: isDarkMode ? '#cccccc' : '#333333'
                      }}>
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Compact Support Section */}
          <div style={{ padding: '4px 0' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11px',
              fontWeight: 600,
              color: isDarkMode ? '#888888' : '#666666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '4px'
            }}>
              Support
            </div>
            
            {[
              { icon: '💬', label: 'Support', path: whatsappLink, external: true }
            ].map((item, index) => (
              <div
                key={index}
                onClick={handleSupportMenuClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>{item.icon}</span>
                <span style={{ 
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  {item.label}
                </span>
              </div>
            ))}

            {showAddToHomeScreen && (
              <div
                onClick={handleAddToHomeScreen}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderLeft: '2px solid transparent'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                  e.target.style.borderLeftColor = 'var(--accent-color)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderLeftColor = 'transparent';
                }}
              >
                <span style={{ fontSize: '16px', marginRight: '12px', width: '20px' }}>📲</span>
                <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}>
                  Add to Home Screen
                </span>
              </div>
            )}
          </div>

          {/* Compact Logout Section */}
          <div style={{
            padding: '12px 16px',
            borderTop: `1px solid ${isDarkMode ? '#333333' : '#e0e0e0'}`,
            marginTop: '8px'
          }}>
            <div
              onClick={doLogin}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderRadius: '6px',
                backgroundColor: isDarkMode ? '#2d2d2d' : '#f8f9fa',
                border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#404040' : '#e9ecef';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#2d2d2d' : '#f8f9fa';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span style={{ fontSize: '16px', marginRight: '12px', color: '#f44336' }}>🚪</span>
              <span style={{ 
                fontSize: '13px',
                fontWeight: 600,
                color: '#f44336'
              }}>
                Logout
              </span>
            </div>
          </div>
        </div>
      </Drawer>

      <Dialog
        open={supportDialogOpen}
        onClose={() => setSupportDialogOpen(false)}
        aria-labelledby="support-dialog-title"
        aria-describedby="support-dialog-description"
      >
        <DialogTitle id="support-dialog-title">Contact support</DialogTitle>
        <DialogContent>
          <DialogContentText id="support-dialog-description">
            Do you really want to contact support!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setSupportDialogOpen(false)} color="inherit">
            Cancel
          </Button> */}
          <Button onClick={handleSupportConfirmNo} color="primary" variant="outlined">
            No
          </Button>
          <Button onClick={handleSupportConfirmYes} color="error" variant="contained" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TitleBar;